var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tc-container"},[_c('div',{staticClass:"tc-chart"},[_c('div',{ref:"myChart",staticClass:"myChart"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }